import React from 'react';

export default function ConversionFlowSteps({ steps, setStep }) {

    const isStepCompleted = (step) => {
        const activeStep = steps.find((step) => step.active);
        return step.position < activeStep.position;
    }

    const activateStep = (step) => {
        if (isStepCompleted(step)) {
            setStep(step);
        }
    }

    return (
        <div className="flow-steps">
            {steps && steps.filter((step) => !step.hidden).map((step) => (
                <div
                    key={step.id}
                    onClick={() => activateStep(step)}
                    className={`flow-step ${isStepCompleted(step) && 'is-complete'} ${step.active && 'is-active'}`}
                >
                </div>

            ))}
        </div>
    )
}
